import React from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar"; 
import EarnBar from '../../components/chart/BarChart/EarnBarChart'
import OrdersBar from '../../components/chart/BarChart/ordersBarChart'
import ProductsBar from '../../components/chart/BarChart/productBarChart'
import UserBar from '../../components/chart/BarChart/userBar'
import EarnLine from '../../components/chart/LineChart/EarnLineChart'
import OrdersLine from '../../components/chart/LineChart/ordersLineChart'
import ProductsLine from '../../components/chart/LineChart/productLineChart'
import UserLine from '../../components/chart/LineChart/userLine'
import EarnPie from '../../components/chart/PieChart/EarnPieChart'
import OrdersPie from '../../components/chart/PieChart/ordersPieChart'
import ProductsPie from '../../components/chart/PieChart/productPieChart'
import UserPie from '../../components/chart/PieChart/userPie'
export default function stats() {

  return (
      <>
      
          <div className="home">
              <Sidebar />
              <div className="homeContainer">
                  <Navbar />
                  <div className="widgets">
                      <h4>Total Earnings in Previous Six Months</h4>                       
                  </div>
                  <div className="charts">
                      <div className='featured'>
                          <EarnPie />                          
                      </div>
                      <br/>
                      <EarnBar />
                  </div>
                  <div className="listContainer">
                      <EarnLine />
                  </div>

                  <div className="widgets">
                      <h4>Total Orders in Previous Six Months</h4>
                  </div>
                  <div className="charts">
                      <div className='featured'>
                          <OrdersPie />
                      </div>
                      <br />
                      <OrdersBar />
                  </div>
                  <div className="listContainer">
                      <OrdersLine />
                  </div>

                  <div className="widgets">
                      <h4>Total Products Added in Previous Six Months</h4>
                  </div>
                  <div className="charts">
                      <div className='featured'>
                          <ProductsPie />
                      </div>
                      <br />
                      <ProductsBar />
                  </div>
                  <div className="listContainer">
                      <ProductsLine />
                  </div>

                  <div className="widgets">
                      <h4>Total Users Added in Previous Six Months</h4>
                  </div>
                  <div className="charts">
                      <div className='featured'>
                          <UserPie />
                      </div>
                      <br />
                      <UserBar />
                  </div>
                  <div className="listContainer">
                      <UserLine />
                  </div>
              </div>
          </div>
      </>
  )
}
